import { useContext, useState } from 'react'
import { Flex, Group, UnstyledButton } from '@mantine/core'
import { IconLogout, IconUserEdit } from '@tabler/icons-react'
import classes from '@components/style/SidebarMenu.module.css'
import { Logo } from './Logo'
import { BackendMenu, menu } from '@config/menus'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { AuthContext } from '@context/AuthContext'
import { modals } from '@mantine/modals'
import FormEditMyProfile from '@components/form/FormEditMyProfile'

const SideBarMenu = () => {
    const location = useLocation()
    const navigate = useNavigate()

    const { checkRole, isAuthenticated, logout } = useContext(AuthContext)

    const [active, setActive] = useState('Billing')
    const cleanmenus = BackendMenu.filter(
        (value: menu) =>
            typeof value.label === 'string' &&
            value.icon !== undefined &&
            checkRole(value.role)
    ) as { icon: React.FC<any>; label: string; path: string }[]

    if (isAuthenticated === false || location.pathname === '/') {
        return <></>
    }
    const links = cleanmenus.map((item) => (
        <Link
            className={classes.link}
            data-active={item.label === active || undefined}
            to={item.path}
            key={item.label}
            onClick={(event) => {
                setActive(item.label)
                navigate(item.path)
            }}
        >
            <item.icon className={classes.linkIcon} stroke={1.5} />
            <span>{item.label}</span>
        </Link>
    ))

    const openEditMyProfile = () =>
        modals.open({
            title: 'แก้ไขโปรไฟล์',
            children: <FormEditMyProfile />,
        })

    return (
        <nav className={classes.navbar}>
            <div className={classes.navbarMain}>
                <Group className={classes.header} justify='space-between'>
                    <Logo />
                </Group>
                {links}
            </div>

            <Flex direction='column' className={classes.footer}>
                <UnstyledButton
                    variant='filled'
                    className={classes.link}
                    onClick={openEditMyProfile}
                >
                    <IconUserEdit className={classes.linkIcon} stroke={1.5} />
                    <span>Edit Profile</span>
                </UnstyledButton>

                <UnstyledButton
                    className={classes.link}
                    onClick={() => logout()}
                >
                    <IconLogout className={classes.linkIcon} stroke={1.5} />
                    <span>Logout</span>
                </UnstyledButton>
            </Flex>
        </nav>
    )
}

export default SideBarMenu
